import { useSetAtom } from 'jotai';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

/**
 * Hook for creating zip archives of files
 */
export const createZipArchiveMutationAtom = createMutationAtomFactory(
  'sales.filesCreateZipArchive',
  (params: { fileIds: string[]; archiveName: string }) => ({
    filesCreateZipArchive: {
      __args: {
        fileIds: params.fileIds,
        archiveName: params.archiveName,
      },
      downloadUrl: true,
      expiresAt: true,
      fileName: true,
      estimatedSize: true,
    },
  }),
);

const $createZipArchive = createZipArchiveMutationAtom();

/**
 * Helper function to create and download a zip archive
 */
export const useCreateZipArchive = () => {
  const createZipArchive = useSetAtom($createZipArchive);

  const createAndDownloadZip = async (
    fileIds: string[],
    archiveName: string,
  ) => {
    try {
      const response = await createZipArchive({
        fileIds,
        archiveName,
      });

      const archive = response.filesCreateZipArchive;
      if (archive?.downloadUrl) {
        // Open the download URL directly
        window.open(archive.downloadUrl, '_blank');
      } else {
        throw new Error('Failed to create zip archive - no file returned');
      }
    } catch (error) {
      console.error('Failed to create zip archive:', error);
      throw error;
    }
  };

  return { createAndDownloadZip, createZipArchive };
};
